
import { Star } from 'lucide-react';
import { formatGuestInfo } from '@/utils/propertyUtils';

interface MobilePropertyHeaderProps {
  title: string;
  rating: number;
  location: string;
  guests: number;
  bedrooms: number;
  bathrooms: number;
}

const MobilePropertyHeader = ({ 
  title, 
  rating, 
  location, 
  guests, 
  bedrooms, 
  bathrooms 
}: MobilePropertyHeaderProps) => {
  return (
    <div className="flex-1">
      <h1 className="text-2xl font-semibold text-gray-900 mb-2">
        {title}
      </h1>
      <div className="flex items-center space-x-4 text-sm mb-2">
        <div className="flex items-center space-x-1">
          <Star className="w-4 h-4 fill-current text-gray-900" />
          <span className="font-medium">{rating}</span>
        </div>
        <span className="text-gray-600 underline">{location}</span>
      </div>
      
      <p className="text-sm text-gray-600">
        {formatGuestInfo(guests, bedrooms, bathrooms)}
      </p>
    </div>
  );
};

export default MobilePropertyHeader;
